"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredMediafiles = exports.excludeMostPlayedMediafiles = exports.excludeMediafilesWithOnetoOneParam = exports.calculateOneToOneSeparate = exports.getAvailableMediafileIds = void 0;
var GenericUtilsService_1 = __importDefault(require("../../GenericUtilsService"));
var ONE_TO_ONE_NORMALIZE = 1.2;
var getAvailableMediafileIds = function (mediafileBlocks, availableBlockIds) {
    return mediafileBlocks.reduce(function (ids, _a) {
        var _b = __read(_a, 2), mediafileId = _b[0], blockId = _b[1];
        if (availableBlockIds.includes(blockId))
            ids.push(mediafileId);
        return ids;
    }, []);
};
exports.getAvailableMediafileIds = getAvailableMediafileIds;
var calculateOneToOneSeparate = function (oneToOneSeparate, mediafilesLength) {
    if (oneToOneSeparate * ONE_TO_ONE_NORMALIZE >= mediafilesLength)
        return Math.floor(mediafilesLength / 2);
    return oneToOneSeparate;
};
exports.calculateOneToOneSeparate = calculateOneToOneSeparate;
var excludeMediafilesWithOnetoOneParam = function (_a) {
    var mediafiles = _a.mediafiles, oneToOneSeparate = _a.oneToOneSeparate, lastRotations = _a.lastRotations, currentPlaylist = _a.currentPlaylist;
    var calculatedOneToOneSeparate = (0, exports.calculateOneToOneSeparate)(oneToOneSeparate, mediafiles.length);
    if (!calculatedOneToOneSeparate)
        return mediafiles;
    var lastRotationMediafileIds = lastRotations.map(function (lastRotation) { return lastRotation.mediafileId; });
    var currentPlaylistMediafileIds = currentPlaylist.map(function (mediafile) { return mediafile.id; });
    var historyMediafileIds = __spreadArray(__spreadArray([], __read(lastRotationMediafileIds), false), __read(currentPlaylistMediafileIds), false);
    var onetooneHistoryMediafileIds = historyMediafileIds.slice(-calculatedOneToOneSeparate);
    return mediafiles.filter(function (mediafile) { return !onetooneHistoryMediafileIds.includes(mediafile.id); });
};
exports.excludeMediafilesWithOnetoOneParam = excludeMediafilesWithOnetoOneParam;
var excludeMostPlayedMediafiles = function (mediafiles) {
    var startDeletedIndex = Math.ceil(mediafiles.length * 0.9);
    return mediafiles.slice(0, startDeletedIndex);
};
exports.excludeMostPlayedMediafiles = excludeMostPlayedMediafiles;
var getFilteredMediafiles = function (_a) {
    var mediafiles = _a.mediafiles, mediafileBlocks = _a.mediafileBlocks, availableBlockIds = _a.availableBlockIds, oneToOneSeparate = _a.oneToOneSeparate, rotatedMediafiles = _a.rotatedMediafiles, lastRotations = _a.lastRotations, currentPlaylist = _a.currentPlaylist;
    var availableMediafileIds = (0, exports.getAvailableMediafileIds)(mediafileBlocks, availableBlockIds);
    var filteredMediafiles = mediafiles.filter(function (mediafile) {
        return availableMediafileIds.includes(mediafile.id);
    });
    filteredMediafiles.sort(function (prev, next) {
        var _a, _b;
        var nextRotated = (_a = rotatedMediafiles[next.id]) !== null && _a !== void 0 ? _a : 0;
        var prevRotated = (_b = rotatedMediafiles[prev.id]) !== null && _b !== void 0 ? _b : 0;
        return prevRotated < nextRotated ? -1 : 1;
    });
    if (filteredMediafiles.length > oneToOneSeparate &&
        GenericUtilsService_1.default.isDeviationNotNormal(Object.values(rotatedMediafiles), 15)) {
        filteredMediafiles = (0, exports.excludeMostPlayedMediafiles)(filteredMediafiles);
    }
    filteredMediafiles = (0, exports.excludeMediafilesWithOnetoOneParam)({
        mediafiles: filteredMediafiles,
        oneToOneSeparate: oneToOneSeparate,
        lastRotations: lastRotations,
        currentPlaylist: currentPlaylist,
    });
    return filteredMediafiles;
};
exports.getFilteredMediafiles = getFilteredMediafiles;
//# sourceMappingURL=getFilteredMediafiles.js.map